var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import Preview from "@/components/widgets/list/preview";
import { useGetModuleListQuery, useGetModuleRecordQuery } from "@/store/api";
import { useState } from "react";
import { FACELIFTDEF } from "@/components/fields/facelift/const";
import DisplayField from "@/components/fields/displayField";
import { FieldViewType } from "@/components/fields/viewType";
/** <b>Composant en mode consultation/detail d'un champ de type parent</b>*/
export default function ParentFieldList(_a) {
    var record = _a.record, fieldMetadata = _a.fieldMetadata, fieldName = _a.fieldName;
    var parent_type = fieldMetadata.type_name;
    var moduleList = useGetModuleListQuery({
        table: record[parent_type],
        params: {},
    }).data;
    var moduleRecord = (moduleList === null || moduleList === void 0 ? void 0 : moduleList.data.records) || [];
    var idFieldName = fieldMetadata.id_name;
    var moduleName = record[parent_type];
    var recordId = record[idFieldName];
    var response = useGetModuleRecordQuery({
        moduleName: moduleName,
        recordId: recordId,
    }).data;
    var parentRecord = (response === null || response === void 0 ? void 0 : response.data.record) || {};
    var relateId = (parentRecord && (parentRecord === null || parentRecord === void 0 ? void 0 : parentRecord.id)) || "";
    var link = "".concat(process.env.PUBLIC_URL, "/modules/").concat(record[parent_type], "/DetailView/").concat(relateId);
    var _b = useState(false), clicked = _b[0], setClicked = _b[1];
    var handleClick = function (value) {
        setClicked(value);
    };
    return (_jsx("div", __assign({ className: "flex flex-row justify-between relative " }, { children: record[fieldName] !== "" && (_jsxs(_Fragment, { children: [_jsx("span", __assign({ className: "items-center mx-2 my-1" }, { children: _jsx(DisplayField, { fieldName: "facelift", viewType: FieldViewType.LIST, fieldMetadata: FACELIFTDEF, record: parentRecord, moduleName: moduleName, hideLabel: true }) })), _jsx("span", __assign({ className: "text-blue-700 hover:text-blue-400 flex items-center w-[2px] flex-1 overflow-hidden" }, { children: _jsx("a", __assign({ href: link, className: "truncate" }, { children: parentRecord && (parentRecord === null || parentRecord === void 0 ? void 0 : parentRecord.name) })) })), _jsx("div", __assign({ className: "pr-2" }, { children: record[fieldName] !== "" && (_jsx(Preview, { record: parentRecord, module: moduleName || "Accounts", handleClick: handleClick })) }))] })) })));
}
